import './polyfills'
import React from 'react'
import ReactDOM from 'react-dom'
import './styles/app.scss'
import App from './App'
import * as serviceWorker from './serviceWorker'
import { StoreProvider } from '@/store'
// import { Intl } from '@/locales';
import { initUserStatus, autoUserConnect } from '@/utils/userHelper'
import { disableUserScalable, listenVirtualkeyboardAction } from './utils/utils'
import $mqtt from '@/api/mqtt'

import FastClick from 'fastclick'

FastClick.attach(document.body)
// initVconsole()

const initApp = async () => {
  await initUserStatus()
  await autoUserConnect()
  $mqtt.connect(data => {
    if (data && data.success) {
      console.log('MQTT连接成功，正在发送测试消息...')

      setTimeout(() => {
        try {
          const linked = localStorage.getItem('userInfo')
            ? JSON.parse(localStorage.getItem('userInfo') || '{}').linked
            : ''

          if (linked) {
            console.log(`测试MQTT发布消息到主题: ${linked}/test`)
            $mqtt.send('test', {
              message: 'Hello MQTT!',
              timestamp: new Date().toISOString(),
            })
          } else {
            console.warn('未找到linked ID，无法发送测试消息')
          }
        } catch (error) {
          console.error('发送测试消息失败:', error)
        }
      }, 2000)
    }
  })
}

Promise.all([
  disableUserScalable(),
  listenVirtualkeyboardAction(),
  initApp(),
]).then(() => {
  ReactDOM.render(
    <StoreProvider>
      {/* <Intl> */}
      <App />
      {/* </Intl> */}
    </StoreProvider>,
    document.getElementById('root'),
  )
  // TODO: Test Version period of validity
  // if (new Date() > new Date('2023/08/01 00:00:00')) {
  //   ;(document.getElementById('root') as HTMLElement).innerHTML = ''
  // }
})

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
